import { ApiError } from '@postifoto/api-client';
import { PROBLEM_TYPES, type ProblemType } from '@postifoto/contracts/client';

export { PROBLEM_TYPES };

/** Тип ошибки API (RFC 9457) — сравниваем с константами, а не с текстом (ADR-032). */
export function problemType(error: unknown): string | null {
  return error instanceof ApiError ? error.problem.type : null;
}

export function isProblem(error: unknown, type: ProblemType): boolean {
  return problemType(error) === type;
}

export function httpStatus(error: unknown): number | null {
  return error instanceof ApiError ? error.status : null;
}

/** Ошибки полей формы из ProblemDetails.errors[]: путь → код ошибки. */
export function fieldErrors(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError)) return {};
  return Object.fromEntries((error.problem.errors ?? []).map((item) => [item.path, item.message]));
}

/** Через сколько секунд можно повторить (429 и блокировки). */
export function retryAfter(error: unknown): number | null {
  if (!(error instanceof ApiError)) return null;
  const value = (error.problem as { retryAfter?: unknown }).retryAfter;
  return typeof value === 'number' ? value : null;
}
